import { render } from "./Abilities.vue?vue&type=template&id=16d98bdd&scoped=true"
import script from "./Abilities.vue?vue&type=script&lang=js"
export * from "./Abilities.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-16d98bdd"

export default script